<template>
  <page-table />
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'customerManage-custBizTeamSet',
  components: { PageTable },
}
</script>
